export namespace IClaim {
  export const Action = 'claims';

  export enum Command {
    Get = 'get',
    Set = 'set',
  }

  export interface IForm {
    carNumber: string;
    claimTypeId: number;
    phone: string;
    comment: string;
  }
}
